import React, {Component} from 'react';
import {connect} from 'react-redux'
import ReportGeneralTable from './ReportGeneralTable'
import ReportStore from '../../stores/ReportStore'
import FontAwesome from 'react-fontawesome';
import {Checkbox} from 'react-icheck'
import {Popover,OverlayTrigger,Breadcrumb} from 'react-bootstrap';
import { momentHelper } from './helpers'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import IframeModal from '../../component/element/IframeModal'
import PaymentVoucherDoc from '../doc/PaymentVoucherDoc'
import JSWorkDocViewModal from 'view/workdoc/JSWorkdocViewModal';
const cHeaderTitles = [
  {title:'วันที่ออก',width:'100px'},
  {title:'ใบสำคัญจ่าย',width:'120px'},  
  {title:'ใบแจ้งหนี้',width:'120px'},
  {title:'ใบงานเลขที่',width:'220px'},
  {title:'ทะเบียนรถ',width:'150px'},
  {title:'ยี่ห้อ',width:'150px'},
  {title:'รุ่น',width:'150px'}, 
  {title:'ชื่อลูกค้า',width:'200px'},
  {title:'มูลค่า(บาท)',width:'100px'},  
]

const cHeaderTitlesAll = [
  {title:'',width:'50px',checkAll:true},
  {title:'วันที่ออก',width:'100px'},
  {title:'ใบสำคัญจ่าย',width:'120px'}, 
  {title:'ใบแจ้งหนี้',width:'120px'} , 
  {title:'ใบงานเลขที่',width:'220px'},
  {title:'ทะเบียนรถ',width:'150px'},
  {title:'ยี่ห้อ',width:'150px'},
  {title:'รุ่น',width:'150px'},  
  {title:'ชื่อลูกค้า',width:'200px'},
  {title:'มูลค่า(บาท)',width:'100px'},        
]

class ReportPaymentVoucherPage extends Component {

  constructor(...args){
    super(...args)
    const month = momentHelper.getMonth()
    const year = momentHelper.getYear()
    const searchBy = 'doc_no'
    const query = ''
    this.state = {
      _that:undefined,
      doc_no:'',
      taxinvoice_no:'',
      doc_title:'ใบสำคัญจ่าย',
      showTable:true,
      data:[],
      companylist:[],
      activeKey:1,
      month: month,
      year: year,
      day : '00',
      searchBy: searchBy,
      query: query,
      activePage: 0,
      itemPerPage:13,
      check:[],
      headerTitles:cHeaderTitlesAll,
      isCheckAll:false,
      showSelectMenu:false,
      pdf_template:{PrintTaxInvoiceCoverNote:'PrintKKCTaxInvoiceCoverNote',PrintTaxInvoiceCoverNoteInsurer:'PrintKKCTaxInvoiceCoverNoteInsurer'}
    }
    this.loadedData = false
  }

  showTable(){
    let {_that} = this.state
    this.setState({showTable:true,doc_no:''})
    if (_that!==undefined) {
      setTimeout(()=>{
        _that.refreshTable() 
      },100)
    }  
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }

  loadDataRange(start,end,searchBy,query,activePage,itemPerPage,callback){
    ReportStore.loadPaymentVoucherListRange('all',start,end,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result)
      callback(result)
    })
  }

  loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback){
    ReportStore.loadPaymentVoucherList('all',year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,(result)=>{
      this.processData(result)
      callback(result)
    })
  }

  processData(result){
    let {headerTitles,activeKey,pdf_template} = this.state
    if (activeKey===1) {
      headerTitles = cHeaderTitlesAll
      result.data = result.data.map((item,index)=>{
        item = Object.assign({check:false},item)
        return item
      })
      this.setState({isCheckAll:false,showSelectMenu:false,check:new Array(result.data.length).fill(false)})
    } else {
      headerTitles = cHeaderTitles
    }
    pdf_template = Object.assign(pdf_template,result.pdf_template)
    this.setState({pdf_template:pdf_template,companylist:result.companylist,headerTitles:headerTitles,data:result.data}) 
  }

  renderStatus(status,row){
    let result = (<span></span>)

    if (row.work_status==='0') {
      result = (<span className="label label-default" data-value="0"><FontAwesome name='clock-o'/> เริ่มต้น</span>)
    }else if (row.work_status==='1') {
      result = (<span className="label label-warning" data-value="1"><FontAwesome name='wrench'/> อยู่ระหว่างซ่อม</span>)
    } else if (row.work_status==='2') {
      result = (<span className="label label-primary" data-value="2"><FontAwesome name='hourglass-start'/> รอส่งมอบรถ</span>)
    } else if (row.work_status==='3') {
      result = (<span className="label label-success" data-value="3"><FontAwesome name='thumbs-o-up'/> ปิดจบงาน</span>)
    } else if (row.work_status==='5') {
      result = (<span className="label label-purple" data-value="5"><FontAwesome name='bitcoin'/> ตั้งเบิก</span>)
    } else{
      result = (<span></span>)
    }

    if(row.doc_status!==undefined && row.doc_status*1===2){
      result = (<div>{result}<span  className="label label-success"><FontAwesome name='money'/> ชำระเงินแล้ว</span></div>)
    }
    if(row.doc_cancel!==undefined && row.doc_cancel*1===1){
      result = (<div>{result}<span  className="label label-danger"><FontAwesome name='trash'/> ยกเลิก</span></div>)
    }

    if(row.doc_cancel_remark!==undefined && row.doc_cancel_remark!==''){
      result = (<div>{result}<span  className="label label-danger"><FontAwesome name='trash'/> {row.doc_cancel_remark}</span></div>)
    }

    return result
  }

  renderWorkNo(data,index){
    if (data!=="" && data!==null) {
      let title = "ใบงานซ่อม "+data
      let popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title={title}>
          <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบงาน</strong>
        </Popover>
      )

      return (
        <div key={index} className='row-inside-table'>
          {data} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,data)} className="text-blue" name='file-text-o'/></OverlayTrigger>
        </div>
      )
    }else{
      return (<span key={index}>{data}</span>)  
    } 
  }

  renderInvoiceNo(data,row){
    if (data!=="" && data!==null) {
      let title = "ใบแจ้งหนี้ "+data
      let popoverHoverFocus = (
        <Popover id="popover-trigger-hover-focus" title={title}>
          <strong>คลิกตรงไอค่อนเพื่อเข้าดูใบแจ้งหนี้</strong>
        </Popover>
      )

      return (
        <span>
          {data} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconTivClick.bind(this,row.taxinvoice_no)} className="text-green" name='file-text-o'/></OverlayTrigger>
        </span>
      )
    }else{
      return (<span>{data}</span>)  
    } 
  }

  onIconClick(workNo,e) {
    // if (process.env.NODE_ENV === "development") {
    //   alert('show_work_doc:'+workNo)
    // }else{
    //   window.show_work_doc(workNo)
    // }
    this.refs.jsWork.loadData(workNo)
  }

  onIconTivClick(tivNo,e) {
    if (process.env.NODE_ENV === "development") {
      alert('show_taxinvoice_doc:'+tivNo)
    }else{
      window.show_taxinvoice_doc(tivNo)
    }
  }

  onCheckChange(rowIndex){
    let {showSelectMenu,check,isCheckAll} = this.state
    check[rowIndex] = !check[rowIndex]

    showSelectMenu = false
    let key = check.findIndex(x=>x!==false)
    if (key!==-1)
      showSelectMenu = true
    
    isCheckAll = this.checkAll(check)
    this.setState({check:check,showSelectMenu:showSelectMenu,isCheckAll:isCheckAll})
  }

  checkAll(check) {
    let {data} = this.state
    let isCheckAll = true
    check.forEach((item,index)=>{
      if (!item&&data[index].work_status!=='3')
        isCheckAll = false
    })
    return isCheckAll
  }

  validateSameCustomer(newItem,checkItems){
    let valid = true
    checkItems.map((item,index)=>{      
      if(item.customer_name!==newItem.customer_name){
        valid = false
      }
      return item
    })

    return valid
  }

  validBeforePrint(_data) {
    let customer_name = []
    _data.forEach((item,index)=>{
      if (item) {
        if (customer_name.indexOf(item.customer_name)===-1)
          customer_name.push(item.customer_name)
      }
    })
    
    return customer_name.length>1?false:true
  }

  onPrintClick(number) {
    let {check,data} = this.state
    let doc_nos = []

    data.forEach(function(item,index) {
      if (check[index]) {
        doc_nos.push(item.doc_no)
      }
    })

    let doc_no = doc_nos.join()
    let file = 'PrintShippingLabel&idlist='+doc_no+'&doc=paymentvoucher'
    let url = ''
    if (process.env.NODE_ENV === "development") {
      if (number===2)
        url = './?startPage='+file
      else
        url  = './?startPage='+file+'&tivlist='+doc_no
    } else{
      if (number===2)
        url = './pdf/v2/?startPage='+file
      else
        url = './pdf/v2/?startPage='+file+'&tivlist='+doc_no
    }
    this.refs.iframe.loadUrl(url)
  }

  renderLineBreakComma(data,field){
    let index = data.indexOf(",");
    if(index>=0){
      var nameArr = data.split(',');
      return (<div>{
        nameArr.map((name,index)=> {
          if (field==='work_no') {
            return(
              this.renderWorkNo(name,index)
            )
          } else {
            return(
              <div key={index} className={name!==''&&name!==' '?'row-inside-table':''}>{name}</div>
            )
          }  
        })  
      } </div>)
    }else{
      return (<span>{data}</span>)
    }
  }
  
  onRenderColumn(data,col,row,rowIndex){
      let {check} = this.state
      if(col===0||col==='checkbox'){
        return (<Checkbox    
          onChange={this.onCheckChange.bind(this,rowIndex)}      
          checked={check[rowIndex]!==false?true:false}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
          disabled={row.work_status==='3'?true:false}
        />)
      } else if (col==='bill_invoice_no') {
        return this.renderInvoiceNo(data,row)       
      } else if (col==='amount') {
        return (<span>{data}</span>)
      }else{ 
        return (<span>{data}</span>) // return this.renderLineBreakComma(data,col)
      }
  }

  onTabsSelect(e) {
    let {headerTitles} = this.state
    if (e===1) {
      headerTitles = cHeaderTitlesAll
    }
    this.setState({activeKey:e,headerTitles:headerTitles})
  }

  onCheckAll() {
    let {data,isCheckAll,check} = this.state
    if (data.length===0)
      return false

    if (!isCheckAll) {
      let newCheck = check.map((item,index)=>{
        if (data[index].work_status==='3')
          return false
        else
          return true
      })
      
      this.setState({isCheckAll:true,check:newCheck,showSelectMenu:true})  
    } else {
      let newCheck = check.map((item,index)=>{
        item = false
        return item
      })
      this.setState({isCheckAll:false,check:newCheck,showSelectMenu:false})
    }    
  }

  onRenderCheckAll() {
    return(
      <th key='th-all' className={'text-center'} style={{width:'50px',maxWidth:'50px'}}>
        <Checkbox
          onChange={this.onCheckAll.bind(this)}
          checked={this.state.isCheckAll}
          checkboxClass="icheckbox_square-blue"
          increaseArea="20%"
          label=""
        >
        </Checkbox>
      </th>
    )
  }

  onDocNew(){
    this.setState({showTable:false})
    this.refs.pvDoc.getWrappedInstance().loadNewDoc((result)=>{
      if (this.props.onDocShow!==undefined)
        this.props.onDocShow(result)
      
    })    
  }

  onRowSelect(item){    
    this.setState({showTable:false,doc_no:item.doc_no},()=>{
      this.refs.pvDoc.getWrappedInstance().loadData(item.doc_no)
    })
    if (this.props.onDocShow!==undefined)
      this.props.onDocShow(item.doc_no)
  }

  onDocClose(){
    this.showTable()
  }

  onRef(that) {
    this.setState({_that:that})
  }

  render(){
    let {showTable,showSelectEror,headerTitles,showSelectMenu,doc_no} = this.state
    let {page} = this.props
    const searchOptions = [
      {
        label: 'ใบสำคัญจ่าย',
        value: 'doc_no'
      },
      {
        label: 'ใบแจ้งหนี้',
        value: 'taxinvoice_no'
      },
      {
        label: 'ใบงานเลขที่',
        value: 'work_no'
      },
      {
        label: 'ทะเบียนรถ',
        value: 'car_registration_no'
      },
      {
        label: 'ลูกค้า/เจ้าของรถ',
        value: 'customer_name'
      },
      {
        label: 'บริษัทประกัน',
        value: 'insurance_name'
      }
    ]

    return (
        <div>
          {this.props.renderMenu!==undefined?this.props.renderMenu():''}
          <div style={{display:showTable?'block':'none'}}>
                  <ReportGeneralTable 
                    ref='rgTable' 
                    title='ใบสำคัญจ่าย' 
                    showTitle={page==='report'?false:true}
                    border={page==='report'?false:true}
                    newTitle='เพิ่มรายการ'
                    showNewButton={page==='report'?false:true}
                    showNewButton={true}
                    showPrintButton={true}
                    showSelectMenu={showSelectMenu}
                    show={true}
                    loadOnShow={false}
                    headerTitles={headerTitles}
                    bodyColumn={['checkbox','doc_date','doc_no','bill_invoice_no','work_no','car_registration_no','brand','model','customer_name','amount']}
                    excludeClickColumn={['work_no','bill_invoice_no']}
                    searchOptions={searchOptions}          
                    searchBy={'doc_no'}
                    loadData={this.loadData.bind(this)}    
                    loadDataRange={this.loadDataRange.bind(this)}
                    onRenderCheckAll={this.onRenderCheckAll.bind(this)}                
                    onRenderColumn={this.onRenderColumn.bind(this)}
                    onRowSelect={this.onRowSelect.bind(this)}
                    onPrintClick={this.onPrintClick.bind(this)}
                    printTitle={'พิมพ์ใบจ่าหน้าซอง'}
                    selectMenuTitle={'สร้างใบปะหน้า'}
                    btnTitlePrint={'พิมพ์ตาราง'}
                    docType={'paymentvoucher'}
                    viewMode={'all'}
                    minWidth={1300}
                    isMobile={this.props.isMobile}
                    mobileFieldMap={{title:'customer_name',amount:'amount',sub_title:'doc_no',date:'doc_date',status:'work_status',sub_status:''}}
                    renderWorkStatus={this.renderStatus.bind(this)} 
                    onRef={this.onRef.bind(this)}
                    onDocNew={this.onDocNew.bind(this)}
                    callOut={this.props.callOut}
                    isSeeMore={true}
                    seeMoreField={['bill_invoice_no','work_no','car_registration_no','brand','model']}
                    seeMoreKey='bill_invoice_no'
                  />
            </div>
            <div style={{display:(!showTable?'':'none')}}>            
              <Breadcrumb>
                <Breadcrumb.Item href="#" onClick={this.onDocClose.bind(this)}><FontAwesome name="table"/> ตารางใบสำคัญจ่าย</Breadcrumb.Item>
                <Breadcrumb.Item href="#" active>
                  <FontAwesome name='file-o'/> ใบสำคัญจ่าย {doc_no}
                </Breadcrumb.Item>            
              </Breadcrumb>     
              <PaymentVoucherDoc                 
                ref='pvDoc' 
                show={!showTable?true:false}
                title={this.state.doc_title}
                docType={'paymentvoucher'}
                docSName={'pv'}
                docName={'paymentvoucher_doc'}
                onClose={this.onDocClose.bind(this)}
              />
            </div>
            <ConfirmPopup show={showSelectEror} title='เกิดช้อผิดพลาด'
              confirmTitle='ทำการเลือกใหม่' cancelTitle='ยกเลิก' message='กรุณาเลือกชื่อลูกค้าหรือประกันเดียวกัน โปรดลองใหม่'
              onConfirm={() => { this.setState({ showSelectEror: false }) }}
              onHide={() => { this.setState({ showSelectEror: false }) }}
            />
            <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
            <JSWorkDocViewModal ref="jsWork" title={'แสดงผลใบงาน '} modal={true} fullScreen={true}/>
        </div>  
    )
  }
}

ReportPaymentVoucherPage.defaultProps = {
  callOut: false
}
export default ReportPaymentVoucherPage = connect(
  (state) => ({messages: state.message.view.report.ReportPaymentVoucherPage}),null,null,{withRef:true}
)(ReportPaymentVoucherPage);





// WEBPACK FOOTER //
// ./src/view/report/ReportPaymentVoucherPage.js